import { useSelector } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';

import { ReactElement, useMemo } from 'react';

import { RootState } from '../store';
import GuardRoute from './GuardRoute';
import {
  findActiveGuardedRoute,
  getCurrentUserProfiles,
  isRouteBlockedForProfiles,
} from './profileRouteAccess';
import { routesConfig } from './routesConfig';

export const ChatGuard = ({ children }: { children: ReactElement }) => {
  const location = useLocation();
  const profile = useSelector((state: RootState) => state.profile.profileData);

  const currentUserProfiles = useMemo(
    () => getCurrentUserProfiles(profile),
    [profile],
  );

  const activeRoute = useMemo(
    () => findActiveGuardedRoute(location.pathname, location.search, routesConfig),
    [location.pathname, location.search],
  );

  const isBlocked = useMemo(
    () => isRouteBlockedForProfiles(activeRoute, currentUserProfiles),
    [activeRoute, currentUserProfiles],
  );

  return <GuardRoute allow={!isBlocked}>{children}</GuardRoute>;
};

const AppRoutes = () => {
  return (
    <Routes>
      {routesConfig.map(route => (
        <Route
          key={route.path}
          path={route.path.split('?')[0]}
          element={
            route.blockedForProfiles?.length ? (
              <ChatGuard>{route.element}</ChatGuard>
            ) : (
              route.element
            )
          }
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;
